import Vue from 'vue'
import _ from 'lodash'
import AuthService from '../../service/auth.js'
import $ from 'jquery'

export default {
  data () {
    return {
      'code': [
        '', '', '', '', '', ''
      ],
      'error': '',
      'isLoggedIn': false
    }
  },
  mounted () {
    this.$refs.code1.focus()
  },
  'methods': {
    login () {
      this.error = ''
      Vue.http.post('login', {
        code: _.join(this.code, '')
      }).then((result) => {
        AuthService.setToken(result.body.token)
        setTimeout(this.$router.push('private'), 800)
      }, () => {
        this.error = 'Wrong code, retry!'
      })
    },
    goNext (num) {
      var el = this.$refs['code' + num]
      if (el.value.length === el.maxLength) {
        this.$refs['code' + (num + 1)].focus()
      }
    },
    goBack (num) {
      this.$refs['code' + num].focus()
    },
    glitch () {
      $('.as-glitch').find('.glitch').addClass('imgloaded')
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/home/home.js